<script>
  let user = JSON.parse(localStorage.getItem('user'));
</script>

<style>
  .profile-container {
    width: 100%;
    max-width: 330px;
    padding: 15px;
    margin: auto;
  }
</style>

<div class="profile-container text-center">
  <h1 class="h3 mb-3">{user.firstName} {user.lastName}</h1>
  <p>{user.email}</p>
  {#if user.nmlsId}
    <p>NMLS Id: {user.nmlsId}</p>
  {/if}

  {#if user.licenseNumber}
    <p>License number: {user.licenseNumber}</p>
  {/if}

</div>
